export const IS_DEBUG = false;
